import type { FC } from "react";
import { PrinterIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Button, ButtonSize, ButtonVariant } from "shared/components";

/**
 * Download PDF is the browser's own print dialog: the page is laid out to print,
 * so there is no second rendering of the report to keep in step with this one.
 *
 * Shared by the owner's page and the previews so a partner checking the preview
 * sees the same button the owner will, in the same place.
 */
export const DownloadPdfButton: FC = () => (
  <Button
    size={ButtonSize.BASE}
    variant={ButtonVariant.BASE}
    onClick={() => window.print()}
    className="print:hidden"
  >
    <span className="flex items-center gap-2">
      <HugeiconsIcon icon={PrinterIcon} size={16} />
      Download PDF
    </span>
  </Button>
);
